// Maps a member's points to a position (0-100) on the tier meter.
//
// The bar segments no longer scale with each tier's points range (they are
// equalized in ContextProviders/theme.js), so a plain 100 * points / maxPoints
// would put the marker in the wrong segment. Instead, find the tier the
// member is in and interpolate within that tier's own segment.
export function getPointsPercentage(tiers, points, maxPoints) {
  const visible = (tiers || []).filter((tier) => tier?.barPercentage > 0);
  if (visible.length === 0) {
    return maxPoints > 0 ? (100 * points) / maxPoints : 0;
  }
  if (!(points >= 0)) return 0;

  const lowerOf = (tier) => tier?.thresholds?.[0]?.value ?? tier?.value ?? 0;
  const upperOf = (index) =>
    index < visible.length - 1 ? lowerOf(visible[index + 1]) : maxPoints;

  let index = visible.findIndex((tier, i) => points < upperOf(i));
  if (index === -1) index = visible.length - 1;

  const lower = lowerOf(visible[index]);
  const upper = upperOf(index);
  let fraction = upper > lower ? (points - lower) / (upper - lower) : 1;
  fraction = Math.min(Math.max(fraction, 0), 1);

  const widthBefore = visible
    .slice(0, index)
    .reduce((sum, tier) => sum + tier.barPercentage, 0);

  return widthBefore + fraction * visible[index].barPercentage;
}
